import React, { Component } from "react";
import { withAppState } from "../../state";
import {
  EpgCategoryContainer,
  EpgEventsContainer,
  ChannelRowContainer,
  BackgroundImageStyled,
  ProgramInnerContainer,
  ProgramTitleStyled,
  ChannelImageContainer,
  ImageStyled,
  IconStyled,
  IconOverlayStyled,
  ProgramListContainer,
  ProgramItemsStyled,
  ProgramSlotStyled,
  ProgramSlotClick,
  ProgramDurationStyled,
  StatusWrapper,
  ProgramDurationGradientBarWrapper,
  ProgressStyled,
  ProgramSlot
} from "./viewStyles/Styled";
import EpgCategoriesHeader from "../../components/EPG/EpgCategories/EpgCategoriesHeader";
import { ArrowsContainer, LayoutLeftArrow, LayoutRightArrow } from "./styles/Styled";
import { AirRemoteArrows } from "../../services/visualLibraryService";
import { Image } from "../../services/visualLibraryService";
import {
  EPG_VIEWS,
  debounce,
  getStatusTagText,
  EVENT_STATUS,
  calculateDurationForSlots,
  ARROW_DIRECTIONS,
  IMAGE_TYPES,
  getCurrentChannelImage,
  getProgress,
  getRemainingTime,
  doNothing
} from "../../utils/epgUtil";
import { directions, i18n } from "../../services/i18nService";
import { onRight, onLeft, onUp, onDown } from "../../utils/epgNavigation";
import { epgGridName } from "./Live";

const PIXELS_TO_REM = 16;
const SECONDS_PER_PIXELS = 8;
const PADDING_AT_START = 16;
const PREFIX_CATEGORY = "secondaryItem";
const POSTFIX_BUTTONS = "passThru";
const FOCUS_CLASS = "focused";
const SELECTED_CLASS = "selected";
const MAIN_MENU = "mainMenu";
const LIMIT_ROW_ITEMS = 3;
const SCROLL_DELAY = 50;
class DynamicEpg extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.currentFocused = React.createRef();
    this.state = {
      rowIndex: 0,
      colIndex: 0,
      currentRowIndex: 0,
      categoryIndex: 0,
      isArrowLeftClicked: false,
      isArrowRightClicked: false
    };
    this.showRows = {
      from: 0,
      to: 3
    };
    this.showCat = {
      from: 0,
      to: 2
    };
    this.currentDirection = null;
    this.ref = null;
    this.clearRefreshTimeout = null;
    this.dynamicViewNavigate = this.dynamicViewNavigate.bind(this);
    this.arrowUp = this.arrowUp.bind(this);
    this.arrowDown = this.arrowDown.bind(this);
    this.arrowLeft = this.arrowLeft.bind(this);
    this.arrowRight = this.arrowRight.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.dynamicViewNavigate = debounce(this.dynamicViewNavigate, 1);
    this.channelRows = this.channelRows.bind(this);
    //this.leftRightArrows = this.leftRightArrows.bind(this);
  }

  async componentDidMount() {
    document.addEventListener("keydown", this.dynamicViewNavigate, false);
    this.updateIndexState();
    if (this.props.dynamicData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events) {
      await this.locateLivePosition(true);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.dynamicData !== this.props.dynamicData) {
      this.resetIndexState();
      if (this.props.dynamicData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events) {
        this.setState(
          {
            colIndex: this.currentLiveIndex
          },
          () => {
            this.scrollToLive();
            this.props.onChange({
              rowIndex: this.state.rowIndex,
              colIndex: this.state.colIndex,
              categoryIndex: this.state.categoryIndex,
              changeView: false
            });
          }
        );
      }
    }

    if (
      prevState.rowIndex !== this.state.rowIndex ||
      prevState.colIndex !== this.state.colIndex ||
      prevState.categoryIndex !== this.state.categoryIndex
    ) {
      if (this.currentDirection === ARROW_DIRECTIONS.down || this.currentDirection === ARROW_DIRECTIONS.up) {
        await this.locateLivePosition(false);
      } else if (this.currentDirection === ARROW_DIRECTIONS.left || this.currentDirection === ARROW_DIRECTIONS.right) {
        await this.scrollToLive();
      }
    }
  }

  async locateLivePosition(isFreshLoad) {
    await this.getLiveIndex();

    this.setState(
      {
        colIndex: isFreshLoad ? this.props.currentLiveIndex : this.currentLiveIndex
      },
      () => {
        this.scrollToLive();
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false
        });
      }
    );
  }
  resetIndexState() {
    this.showRows = {
      from: 0,
      to: 3
    };
    this.showCat = {
      from: 0,
      to: 2
    };
    this.setState(
      {
        rowIndex: 0,
        currentRowIndex: 0,
        colIndex: 0,
        categoryIndex: 0
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false,
          showRows: this.showRows,
          showCat: this.showCat
        })
    );
  }

  updateIndexState() {
    this.setState({
      rowIndex: this.props.changeViewRowIndex,
      currentRowIndex: this.props.currentRowIndex,
      colIndex: 0,
      categoryIndex: this.props.categoryIndex
    });
    this.showRows = this.props.visibleRows;
    this.showCat = this.props.visibleCat;
  }

  componentWillUnmount() {
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    document.removeEventListener("keydown", this.dynamicViewNavigate, false);
  }

  async getLiveIndex() {
    const self = this;
    this.props.dynamicData[this.state.categoryIndex].data[this.state.rowIndex].events.filter(function(event, index) {
      if (event.status === EVENT_STATUS.live) {
        self.currentLiveIndex = index;
        return true;
      }
    });
  }

  async scrollToLive() {
    this.setState({ className: "focused" }, () => {
      if (this.currentFocused.current) {
        const focusedElement = this.currentFocused.current;
        const leftOffset = focusedElement.offsetLeft;
        const offsetWidth = focusedElement.offsetWidth;
        // Calculate the right offset in an RTL layout
        const rightOffset =
          leftOffset + (offsetWidth - document.querySelector(".programs").offsetWidth) + PADDING_AT_START;
        const scrollableSlots = document.querySelectorAll(".programs");

        scrollableSlots.forEach(element => {
          element.scrollLeft = i18n.getDirection() === directions.LEFT_TO_RIGHT ? leftOffset : rightOffset;
        });
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          leftOffset: leftOffset,
          rightOffset: rightOffset
        });
        this.setState({ className: "" });
      }
    });
  }

  dynamicViewNavigate = async event => {
    if (
      this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY ||
      this.props.applicationState.currentFocus.split("_")[1] === POSTFIX_BUTTONS ||
      this.props.applicationState.currentFocus === MAIN_MENU ||
      this.props.isFullScreen === true
    ) {
      return;
    }
    this.setState({ isArrowLeftClicked: false });
    this.setState({ isArrowRightClicked: false });
    this.props.onUpdateWheelState("idle");
    this.getArrowDirection(event.keyCode);
    let currentRowLength = this.props.dynamicData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events?.length;
    let totalRows = this.props.dynamicData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.dynamicData?.length;
    let perviousCatTotalRows =
      totalCat > 1 && this.state.categoryIndex > 0
        ? this.props.dynamicData[this.state.categoryIndex - 1]?.data.length
        : this.props.dynamicData[this.state.categoryIndex]?.data.length;
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      event.keyCode === 37 && onRight.call(this, currentRowLength);
      event.keyCode === 39 && onLeft.call(this, currentRowLength);
    } else {
      event.keyCode === 37 && onLeft.call(this, currentRowLength);
      event.keyCode === 39 && onRight.call(this, currentRowLength);
    }
    if (totalRows >= 1) {
      event.keyCode === 38 && onUp.call(this, totalRows, totalCat, perviousCatTotalRows);
      event.keyCode === 40 && onDown.call(this, totalRows, totalCat);
    }
  };

  arrowUp() {
    let totalRows = this.props.dynamicData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.dynamicData?.length;
    let perviousCatTotalRows =
      totalCat > 1 && this.state.categoryIndex > 0
        ? this.props.dynamicData[this.state.categoryIndex - 1]?.data.length
        : this.props.dynamicData[this.state.categoryIndex]?.data.length;

    onUp.call(this, totalRows, totalCat, perviousCatTotalRows);
  }

  arrowDown() {
    let totalRows = this.props.dynamicData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.dynamicData?.length;
    onDown.call(this, totalRows, totalCat);
  }

  getCurrentRowLength() {
    return this.props.dynamicData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events?.length;
  }

  arrowLeft(event) {
    event.stopPropagation();
    let rowLength = this.getCurrentRowLength();
    this.currentDirection =
      i18n.getDirection() === directions.RIGHT_TO_LEFT ? ARROW_DIRECTIONS.right : ARROW_DIRECTIONS.left;
    this.setState({ isArrowLeftClicked: true });
    this.setState({ isArrowRightClicked: false });
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      onRight.call(this, rowLength);
    } else {
      onLeft.call(this, rowLength);
    }

    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      this.props.actions.setFocus(epgGridName);
      this.props.actions.stateActions.setLastFocusedName(epgGridName);
    }
    this.props.actions.pauseNavigation();
  }

  arrowRight(event) {
    event.stopPropagation();
    let rowLength = this.getCurrentRowLength();
    this.currentDirection =
      i18n.getDirection() === directions.RIGHT_TO_LEFT ? ARROW_DIRECTIONS.left : ARROW_DIRECTIONS.right;
    this.setState({ isArrowRightClicked: true });
    this.setState({ isArrowLeftClicked: false });
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      onLeft.call(this, rowLength);
    } else {
      onRight.call(this, rowLength);
    }
    if (i18n.getDirection() === directions.LEFT_TO_RIGHT) {
      this.props.actions.setFocus(epgGridName);
      this.props.actions.stateActions.setLastFocusedName(epgGridName);
    }
    this.props.actions.pauseNavigation();
  }

  async onMouse(isLeftArrow, isRightArrow) {
    this.setState({ isArrowLeftClicked: isLeftArrow });
    this.setState({ isArrowRightClicked: isRightArrow });
  }

  leftRightArrows() {
    const LeftRightArrowStyles = {
      display: this.props.wheelState === "active" ? "block" : "none"
    };
    const { isArrowLeftClicked, isArrowRightClicked } = this.state;
    return (
      <ArrowsContainer>
        <LayoutLeftArrow
          onClick={e => {
            this.arrowLeft(e);
          }}
          onMouseEnter={() => this.onMouse(true, false)}
          onMouseLeave={() => this.onMouse(false, false)}
          style={LeftRightArrowStyles}
        >
          <AirRemoteArrows
            arrowDirection={i18n.getDirection() === directions.RIGHT_TO_LEFT ? "right" : "left"}
            isHover={isArrowLeftClicked}
          ></AirRemoteArrows>
        </LayoutLeftArrow>
        <LayoutRightArrow
          onClick={e => {
            this.arrowRight(e);
          }}
          onMouseEnter={() => this.onMouse(false, true)}
          onMouseLeave={() => this.onMouse(false, false)}
          style={LeftRightArrowStyles}
        >
          <AirRemoteArrows
            arrowDirection={i18n.getDirection() === directions.RIGHT_TO_LEFT ? "left" : "right"}
            isHover={isArrowRightClicked}
          ></AirRemoteArrows>
        </LayoutRightArrow>
      </ArrowsContainer>
    );
  }

  async scrollUpDown(event) {
    if (this.props.applicationState.currentFocus !== epgGridName) {
      this.props.actions.setFocus(epgGridName);
    }
    this.props.onUpdateWheelState("active");
    if (event.deltaY > 0) {
      // down wheel move
      this.currentDirection = ARROW_DIRECTIONS.down;
      await this.reloadWait(SCROLL_DELAY);
      this.arrowDown();
    } else if (event.deltaY < 0) {
      // up wheel moves
      this.currentDirection = ARROW_DIRECTIONS.up;
      await this.reloadWait(SCROLL_DELAY);
      this.arrowUp();
    }
  }

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }

  getArrowDirection(code) {
    if (code === 37) this.currentDirection = ARROW_DIRECTIONS.left;
    if (code === 39) this.currentDirection = ARROW_DIRECTIONS.right;
    if (code === 38) this.currentDirection = ARROW_DIRECTIONS.up;
    if (code === 40) this.currentDirection = ARROW_DIRECTIONS.down;
  }

  channelRows(channelData, channelIndex, catIndex, isOnCurrentRow, hasSelectedProgram) {
    const { currentVideoMetaData, onClickEpgSlots, applicationState } = this.props;
    const { currentRowIndex, colIndex } = this.state;

    return channelData.events?.map((event, eventIndex) => {
      const isFocused =
        applicationState.currentFocus === epgGridName &&
        colIndex === eventIndex &&
        currentRowIndex === channelIndex &&
        catIndex === 0;
      const isSelected = currentVideoMetaData && event.id === currentVideoMetaData.id;

      return (
        <ProgramSlot>
          <ProgramSlotStyled
            direction={i18n.getDirection()}
            key={`ProgramSlotStyled-${eventIndex}`}
            className={`${isFocused && FOCUS_CLASS} ${isSelected && SELECTED_CLASS}`}
            slotWidth={this.widthTimeSlot(event.tsStart, event.tsEnd)}
            viewType={EPG_VIEWS.dynamic}
            ref={
              colIndex === eventIndex && currentRowIndex === channelIndex && catIndex === 0 ? this.currentFocused : null
            }
          >
            <ProgramSlotClick
              slotWidth={this.widthTimeSlot(event.tsStart, event.tsEnd)}
              viewType={EPG_VIEWS.dynamic}
              onClick={isFocused ? onClickEpgSlots : doNothing()}
            >
              <ProgramInnerContainer>
                <ProgramTitleStyled direction={i18n.getDirection()}>{event.title}</ProgramTitleStyled>
                <>
                  {event.status === EVENT_STATUS.live ? (
                    <ProgramDurationGradientBarWrapper>
                      <ProgramDurationStyled direction={i18n.getDirection()}>
                        {i18n.get(`pages.livePage.time.threeleft`, getRemainingTime(event))}
                      </ProgramDurationStyled>
                      <ProgressStyled
                        playback={getProgress(event.tsStart, event.tsEnd)}
                        height="0.22rem"
                        isFromEPG={true}
                        isSelected={isSelected}
                      />
                    </ProgramDurationGradientBarWrapper>
                  ) : (
                    <ProgramDurationStyled direction={i18n.getDirection()}>
                      {calculateDurationForSlots(event.tsStart, event.tsEnd)}
                    </ProgramDurationStyled>
                  )}
                </>
                {isOnCurrentRow && (
                  <StatusWrapper
                    status={getStatusTagText(event.status, channelData.type)}
                    direction={i18n.getDirection()}
                  >
                    {i18n.get(`pages.livePage.tags.${getStatusTagText(event.status, channelData.type)}`)}
                  </StatusWrapper>
                )}
              </ProgramInnerContainer>
            </ProgramSlotClick>
          </ProgramSlotStyled>
        </ProgramSlot>
      );
    });
    // .filter((event, itemIndex) =>
    //   colIndex > -1
    //     ? colIndex < itemIndex + LIMIT_ROW_ITEMS && colIndex >= itemIndex - LIMIT_ROW_ITEMS
    //     : colIndex < itemIndex + LIMIT_ROW_ITEMS * 2 && colIndex >= itemIndex - LIMIT_ROW_ITEMS * 2
    // );
  }

  widthTimeSlot = (startTime, endTime) => {
    return parseFloat(parseFloat((endTime - startTime) / SECONDS_PER_PIXELS) / PIXELS_TO_REM) - 1;
  };

  render() {
    const { currentVideoMetaData, dynamicData, applicationState } = this.props;
    const { currentRowIndex, colIndex } = this.state;
    return (
      <div
        onWheel={e => {
          this.scrollUpDown(e);
        }}
      >
        {this.leftRightArrows()}
        <EpgCategoryContainer>
          {dynamicData.slice(this.showCat.from, this.showCat.to).map((categoryData, catIndex) => (
            <div key={`EpgCategoryContainer-${catIndex}`}>
              <EpgCategoriesHeader heading={categoryData.heading} />
              <EpgEventsContainer>
                {categoryData.data.length > 0 &&
                  categoryData.data.slice(this.showRows.from, this.showRows.to).map((channelData, channelIndex) => {
                    const isOnCurrentRow =
                      applicationState.currentFocus === epgGridName &&
                      currentRowIndex === channelIndex &&
                      catIndex === 0;
                    const hasSelectedProgram =
                      currentVideoMetaData && channelData.events?.some(event => event.id === currentVideoMetaData.id);
                    return (
                      <ChannelRowContainer key={`ChannelRowContainer-${channelIndex}`}>
                        <ChannelImageContainer>
                          <BackgroundImageStyled isSelected={hasSelectedProgram}>
                            {!channelData.isUserSubscribedToChannel && (
                              <IconStyled name="lock">
                                <IconOverlayStyled name="lock" />
                              </IconStyled>
                            )}
                            <ImageStyled>
                              <Image
                                url={
                                  isOnCurrentRow
                                    ? getCurrentChannelImage(channelData, IMAGE_TYPES.logoPng)
                                    : getCurrentChannelImage(channelData, IMAGE_TYPES.darkLogoPng)
                                }
                                alt={channelData.title}
                              />
                            </ImageStyled>
                          </BackgroundImageStyled>
                        </ChannelImageContainer>
                        <ProgramListContainer className={"programs"} direction={i18n.getDirection()}>
                          <ProgramItemsStyled direction={i18n.getDirection()} className={"programsList"}>
                            {this.channelRows(channelData, channelIndex, catIndex, isOnCurrentRow, hasSelectedProgram)}
                          </ProgramItemsStyled>
                        </ProgramListContainer>
                      </ChannelRowContainer>
                    );
                  })}
              </EpgEventsContainer>
            </div>
          ))}
        </EpgCategoryContainer>
      </div>
    );
  }
}
export default withAppState(DynamicEpg);
